export const paymentSuccessful = {
    event: "payment_successful",
    eventAction: "payment succesful_fired",
    eventCategory: "Challan_pay"
};

export const paymentPending = {
    event: "payment_pending",
    eventAction: "payment Payment_pending_fired",
    eventCategory: "Challan_pay"
};

export const paymentFailed = {
    event: "payment_failed",
    eventAction: "payment Payment_failed_fired",
    eventCategory: "Challan_pay"
};

export const paymentRetry = {
    event: "payment_retry",
    eventAction: "Payment _retry_clicked",
    eventCategory: "Challan_pay"
};
